import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "calendar",
	"data-name": "calendar",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 1.48,
			y: 3.37,
			width: 21.04,
			height: 4.78
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 1.48,
			y: 8.15,
			width: 21.04,
			height: 14.35
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.3,
			y1: 12.93,
			x2: 7.22,
			y2: 12.93
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 9.13,
			y1: 12.93,
			x2: 11.04,
			y2: 12.93
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12.96,
			y1: 12.93,
			x2: 14.87,
			y2: 12.93
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 16.78,
			y1: 12.93,
			x2: 18.7,
			y2: 12.93
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 16.78,
			y1: 17.72,
			x2: 18.7,
			y2: 17.72
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.3,
			y1: 17.72,
			x2: 7.22,
			y2: 17.72
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 9.13,
			y1: 17.72,
			x2: 11.04,
			y2: 17.72
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12.96,
			y1: 17.72,
			x2: 14.87,
			y2: 17.72
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 6.26,
			y1: .5,
			x2: 6.26,
			y2: 5.28
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .5,
			x2: 12,
			y2: 5.28
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 17.74,
			y1: .5,
			x2: 17.74,
			y2: 5.28
		})
	]
});
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
